// extracted by css-extract-rspack-plugin
export default {"linkButtonBlock":"RichTextLinkButton_linkButtonBlock__0F6jO"};